module.exports = __webpack_public_path__ + "static/img/amg-energia-2.27edcbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/amg-energia-2.jpg
// module id = v75q
// module chunks = 1